export default __webpack_public_path__ + "static/media/close.632851a9.svg";